import Media from './../mediaDetect.js'; //Детектор медиа

var mapHowGetThere,
    coordsExpocenter = [55.75196856899675,37.545294],
    currentAdressFrom = '',
    startAutoSuggestView,
    startMasstransitSuggestView,
    lang = $('html').attr('lang');

let Map = {
    initTabs: function(tab){

        if(!tab.hasClass('active')) {
            let container = tab.closest('[data-map-tabs]'),
            value = tab.data('item-nav-map-tabs');

            container.find('[data-pane-map-tabs]').removeClass('active');
            container.find('[data-item-nav-map-tabs]').removeClass('active');

            tab.addClass('active');
            container.find('[data-pane-map-tabs="' + value + '"]').addClass('active');

            // После переключения таба может измениться высота блока с инфой,
            // поэтому обновляем размеры карты
            if (mapHowGetThere) {
                mapHowGetThere.container.fitToViewport();
            }
        }
    },
    initMap: function(){
        // Дождёмся загрузки API и готовности DOM.
        ymaps.ready(init);

        function init () {
            var _zoom = 16;

            if(!startAutoSuggestView && !startMasstransitSuggestView) {
                startAutoSuggestView = new ymaps.SuggestView('START_ROUTE_MAP_AUTO');
                startMasstransitSuggestView = new ymaps.SuggestView('START_ROUTE_MAP_MASSTRANSIT');
            }

            // Создание экземпляра карты и его привязка к контейнеру с заданным id ("map").
            mapHowGetThere = new ymaps.Map('map-how-get-there', {
                // При инициализации карты обязательно нужно указать её центр и коэффициент масштабирования.
                center: coordsExpocenter, // Экспоцентр
                zoom: _zoom,
                controls: ['zoomControl']

            }, {
                searchControlProvider: 'yandex#search'
            });

            mapHowGetThere.behaviors.disable('scrollZoom');

            Map.addPlacemarkExpocenter();
            Map.setCenterMap(_zoom);
        }
    },
    addPlacemarkExpocenter: function(){
        mapHowGetThere.geoObjects.add(new ymaps.Placemark(coordsExpocenter, {
            iconCaption: (lang === 'en') ? 'Expocentre' : 'Экспоцентр'
        }, {
            preset: 'islands#icon',
            iconColor: '#f05f3b'
        }));
    },
    setCenterMap: function(zoom) {

        var widthContainer = $('[data-container-info-map-how-get-there]').width(),
            mapHeight = $('[data-map-how-get-there]').height();

        if(Media.detect().isDesktop){
            var deltaX = (widthContainer/12)*(5/2),
                deltaY = mapHeight/2 - 200;

            mapHowGetThere.panTo(coordsExpocenter).then(function () {
                var position = mapHowGetThere.getGlobalPixelCenter();
                mapHowGetThere.setGlobalPixelCenter([ position[0] - deltaX, position[1] + deltaY ]);
            });
        }
    },
    getDirections: function(typeRoute){
        // При перестроении маршрута удаляем все геообъекты с карты
        mapHowGetThere.geoObjects.removeAll();
        Map.addPlacemarkExpocenter();

        if(currentAdressFrom != ''){
            // С помощью прямого геокодирования получаем координаты конечной точки
            // и добавляем ее на карту как метку с подписью
            ymaps.geocode(currentAdressFrom, {
                results: 1
            }).then(function (res) {
                // Выбираем первый результат геокодирования.
                var firstGeoObject = res.geoObjects.get(0),
                    // Координаты геообъекта.
                    coords = firstGeoObject.geometry.getCoordinates();

                mapHowGetThere.geoObjects.add(new ymaps.Placemark(coords, {
                    iconCaption: firstGeoObject.properties.get('name')
                }, {
                    preset: 'islands#icon',
                    iconColor: '#f05f3b'
                }));
            });

            // Задаём параметры маршрута
            var multiRoute = new ymaps.multiRouter.MultiRoute(
                {
                    // Описание опорных точек мультимаршрута.
                    referencePoints: [
                        currentAdressFrom,
                        coordsExpocenter
                    ],
                    // Параметры маршрутизации.
                    params: {
                        routingMode: typeRoute,
                        // Ограничение на максимальное количество маршрутов, возвращаемое маршрутизатором.
                        results: 1
                    }
                }, {
                    // Позволяет скрыть иконки путевых точек маршрута.
                    wayPointVisible:false,

                    // Позволяет скрыть точечные маркеры путевых точек.
                    pinVisible:false,

                    // Автоматически устанавливать границы карты так, чтобы маршрут был виден целиком.
                    boundsAutoApply: true
                }
            );

            // Добавляем мультимаршрут на карту.
            mapHowGetThere.geoObjects.add(multiRoute);

            // Создаём список действий по маршруту и выводим его в окно информации
            var pathList = '';
            var staticTextAbout = (lang === 'en') ? 'About' : 'Около';
            multiRoute.events.add('update',function () {
                // Возвращает дочернюю коллекцию единичных маршрутов мультимаршрута.
                multiRoute.getRoutes().each(function (route) {
                    // Возвращает массив путей маршрута.
                    route.getPaths().each(function (path) {

                        var pathProperties = path.properties.getAll();
                        pathList += '<div class="path-route-map__title">' + pathProperties.distance.text + 
                                    '. '+ staticTextAbout + ' ' + pathProperties.duration.text + '</div>';

                        // Возвращает массив сегментов пути.
                        path.getSegments().each(function (segment) {
                            var segmentProperties = segment.properties.getAll();

                            var optionsAuto =   '<div class="item-path-results__data">'+
                                                    '<div class="distance">' + segmentProperties.distance.text + '</div>' +
                                                    '<div class="duration">. '+ staticTextAbout + ' ' + segmentProperties.duration.text + '</div>' +
                                                '</div>';

                            var optionsResult = (typeRoute == 'auto') ? optionsAuto : '';
                            pathList += '<div class="item-path-results">' + 
                                            '<div class="item-path-results__text">' + segmentProperties.text + '</div>' +
                                            optionsResult +
                                        '</div>'
                        });
                    });
                });

                var drivingPathRoute = $('[data-path-route-map-how-get-there="' + typeRoute + '"]'),
                    drivingContentPathRoute = drivingPathRoute.find('[data-path-content-route-map-how-get-there]'),
                    nanoPathRoute = drivingPathRoute.find('.nano');

                drivingContentPathRoute.html(pathList);
                
                if (!drivingPathRoute.hasClass('show')) {
                    drivingPathRoute.addClass('show');
                    mapHowGetThere.container.fitToViewport();
                }

                nanoPathRoute.nanoScroller();
            });

            multiRoute.events.add("boundsautoapply", function () {
                if(!Media.detect().isMobile){
                    var coordsRoute = multiRoute.getPixelBounds(),
                        widthRoute = Math.abs(coordsRoute[0][0] - coordsRoute[1][0]),
                        widthContainer = $('[data-container-info-map-how-get-there]').width(), // ширина контейнера без паддингов
                        withTabs = $('[data-map-tabs]').outerWidth(),
                        deltaTabs = widthContainer/2 - withTabs, // насколько блок табов больше/меньше половины ширины контейнера
                        deltaRoute = widthRoute/2 - deltaTabs, // смещение маршрута, чтобы левая его граница оказалась по правую границу от табов
                        deltaResult = 0;

                    if((widthContainer - withTabs) > widthRoute) {
                        var sidewalls = $('[data-wrap-map-how-get-there]').width() - widthContainer, // получаем ширину полей за пределами контейнера https://i.imgur.com/gS7ulfq.png
                            widthRightViewArea = widthContainer - withTabs + sidewalls/2; // ширина видимой области справа от табов. 

                        deltaResult = deltaRoute + widthRightViewArea/2 - widthRoute/2; // https://i.imgur.com/5mY1aZv.png
                    }else{
                        deltaResult = deltaRoute + 20; // 20 - произвольное число, чтобы маршрут не прилипал к блоку с табами
                    }

                    var position = mapHowGetThere.getGlobalPixelCenter();
                    mapHowGetThere.setGlobalPixelCenter([position[0] - deltaResult, position[1]]);
                }
            });
        }
    },
    clearRoute: function(){
        // Для всех инпутов маршрутов
        $('[data-input-route-map-how-get-there]').each(function(index) {
            var _this = $(this), // текущий инпут
                currContentTab = _this.closest('[data-pane-map-tabs]'),
                currInfo = currContentTab.find('[data-path-route-map-how-get-there]'),
                currInfoContent = currInfo.find('[data-path-content-route-map-how-get-there]'),
                btnClear = currContentTab.find('[data-btn-clear-route-map-how-get-there]');

            // Очищаем поля ввода
            _this.val('');
            // Скрываем кнопку очищения
            btnClear.removeClass('show')
            // Скрываем описание маршрута
            currInfo.removeClass('show');
            // Очищаем ранее заполненные детальные данные маршрута
            currInfoContent.empty();
        });

        // Удаляем все геообъекты с карты
        mapHowGetThere.geoObjects.removeAll();
        // Добавляем метку Экспоцентра
        Map.addPlacemarkExpocenter();
        // Центрируем карту относительно метки
        var state = mapHowGetThere.action.getCurrentState();
        Map.setCenterMap(state.zoom);

        // Очищаем текущий адрес
        currentAdressFrom = '';
    },
    initDraggable: function(_drag){
        _drag.draggable({
            containment: "[data-wrap-map-how-get-there]",
            scroll: false
        });
    },
    setDraggableInfo: function(infoMap){
        if(!Media.detect().isMobile){
            Map.initDraggable(infoMap);
        }

        $(window).on('mdbreakpoint', function(e, breakpointOld, breakpointOldNew) {
            var isDrag = infoMap.hasClass('ui-draggable');

            if(breakpointOldNew === 'isMobile'){
                if(isDrag) {
                    infoMap.css({'top': '0', 'left': '0'}).draggable("option", "disabled", true);
                }
            }else{
                if(isDrag) {
                    infoMap.draggable("enable");
                }else{
                    Map.initDraggable(infoMap);
                }
            }

            if(breakpointOldNew === 'isTablet' && (breakpointOld === 'isMobile' || breakpointOld === 'isDesktop' || breakpointOld === 'isDesktopHD')) {
                infoMap.css({'top': '0'});
            }
        });

        $(window).resize(function(event) {
            var newLeft = parseInt($('[data-wrap-map-how-get-there]').innerWidth()/2 + $('[data-container-info-map-how-get-there]').width()/2 - infoMap.innerWidth());
            if(parseInt(infoMap.css('left')) > newLeft){
                infoMap.css('left', newLeft)
            }
        });
    }
}

$(document).ready(function($) {
    let infoMap = $('[data-info-map-how-get-there]');
    if(infoMap.length) {
        Map.setDraggableInfo(infoMap);
    }

    let itemTabsMap = $('[data-item-nav-map-tabs]');
    if(itemTabsMap.length) {

        itemTabsMap.on('click', function(){
            var _this = $(this),
                typeRoute = _this.data('type-route-map-tab'),
                mapTabs = _this.closest('[data-map-tabs]'),
                newActiveContentTab = mapTabs.find('[data-pane-map-tabs="' + _this.data('item-nav-map-tabs') + '"]');

            if(!_this.hasClass('active') && typeRoute) {
                // Устанавливаем в инпут сохранённое значение адреса
                newActiveContentTab.find('[data-input-route-map-how-get-there]').val(currentAdressFrom);

                if(currentAdressFrom == '') {
                    $('[data-btn-clear-route-map-how-get-there]').removeClass('show');
                }

                // Делаем реинит автоподсказок яндекса для полей адреса
                if(startAutoSuggestView && startMasstransitSuggestView) {
                    startAutoSuggestView.destroy();
                    startMasstransitSuggestView.destroy();

                    startAutoSuggestView = new ymaps.SuggestView('START_ROUTE_MAP_AUTO');
                    startMasstransitSuggestView = new ymaps.SuggestView('START_ROUTE_MAP_MASSTRANSIT');
                }

                Map.getDirections(typeRoute);
            }
            
            Map.initTabs(_this);
        });
    }

    if($('[data-map-how-get-there]').length) {
        Map.initMap();
    }

    let btnBuildRouteMapHowGetThere = $('[data-btn-build-route-map-how-get-there]');
    if(btnBuildRouteMapHowGetThere.length){

        btnBuildRouteMapHowGetThere.on('click', function(){
            var _this = $(this),
                typeRoute = _this.data('btn-build-route-map-how-get-there'),
                currentInput = _this.closest('[data-pane-map-tabs]').find('[data-input-route-map-how-get-there]');

            currentAdressFrom = currentInput.val();
            Map.getDirections(typeRoute);
        });
    }

    $('[data-btn-clear-route-map-how-get-there]').on('click', function(){
        Map.clearRoute();
    });

    $('[data-input-route-map-how-get-there]').on('input', function(){
        var inputRoute = $(this),
            btnClear = $('[data-btn-clear-route-map-how-get-there]');

        if(inputRoute.val() == ''){
            // Скрываем кнопку очищения
            btnClear.removeClass('show');
            // Очищаем карту
            Map.clearRoute();
        }else{
            btnClear.addClass('show');
        }
    });

    let toggleMapHowGetThere = $('[data-toggle-info-map-how-get-there]');
    if(toggleMapHowGetThere.length) {

        var wrapInfo = $('[data-wrap-info-map-how-get-there]'),
            wrapMap = $('[data-wrap-map-how-get-there]');

        toggleMapHowGetThere.on('click', function(e){
            e.stopPropagation();
            e.preventDefault();

            if(wrapInfo.hasClass('hide-info')) {
                wrapInfo.removeClass('hide-info');
                infoMap.removeClass('close').animate({ 'left': 0 }, 200, "linear", function(){
                    if(infoMap.hasClass('ui-draggable')) {
                        infoMap.draggable("enable");
                    }
                });
            }else{
                // 24 - отступ блока справа
                var leftPosition = (wrapMap.innerWidth() - wrapMap.find('[data-container-info-map-how-get-there]').width())/2 + infoMap.innerWidth() - 24;

                wrapInfo.addClass('hide-info');
                infoMap.addClass('close').animate({ 'left': -leftPosition }, 200, "linear", function(){
                    if(infoMap.hasClass('ui-draggable')) {
                        infoMap.draggable("option", "disabled", true);
                    }
                });
            }
        });

        toggleMapHowGetThere.on('mousedown', function(e){
            e.stopPropagation();
            e.preventDefault();
        });

        wrapInfo.on('click', '[data-info-map-how-get-there].close', function(){
            wrapInfo.removeClass('hide-info');
            infoMap.removeClass('close').animate({ 'left': 0 }, 200, "linear", function(){
                if(infoMap.hasClass('ui-draggable')) {
                    infoMap.draggable("enable");
                }
            });
        });

        $(window).resize(function(event) {
            if(wrapInfo.hasClass('hide-info')) {
                // 24 - отступ блока справа
                var leftPosition = wrapInfo.offset().left + infoMap.innerWidth() - 24;

                wrapInfo.addClass('hide-info');
                infoMap.css('left', -leftPosition);
            }
        });
    }
});


// WEBPACK FOOTER //
// ./components/map.js